import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getPermissions } from '../lib/accessControl';
import useUser from '../hooks/useUser';
import SideBar from './SideBar';

const SidebarNavigation = ({ logOut = () => {}, component }) => 
{
    const navigate = useNavigate();

    /* AUTHENTICATION VARIABLES */
    const currentUser = useUser();
    
    /* AUTHORIZATION VARAIBLES */
    const businessUnits = getPermissions(currentUser?.role, null, "businessUnits");

    useEffect(() =>
    {
        const isLoggedIn = localStorage.getItem("isLoggedIn") || false;

        if (businessUnits.length > 0 && !isLoggedIn)
        {
            const firstUnit = businessUnits[0];

            localStorage.setItem("isLoggedIn", JSON.stringify(true));
            navigate(`/deals/${firstUnit?.value?.toLowerCase()}`, {
                state: { selectedBusinessUnit: firstUnit }
            });
        }
    
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, [businessUnits]);
    
    return (
        <SideBar 
            currentUser = {currentUser} 
            component = {component} 
            businessUnits = {businessUnits}
            logOut = {logOut} 
        />
    );
}

export default SidebarNavigation;